import auth from "./resources/auth";
import blog from "./resources/blog";
import country from "./resources/country";
import contact from './resources/contact';
import director from "./resources/director";
import industry from "./resources/industry";
import platform from "./resources/platform";
import provider from "./resources/provider";
import userResource from "./resources/user";
import leadResource from './resources/lead';
import activityResource from './resources/activity';
import partnerResource from './resources/partner';
import nationality from "./resources/nationality";
import companiesHouse from "./resources/companiesHouse";
import leadSourceResource from './resources/leadSource';
import applicationResource from './resources/application';
import applicationFields from "./resources/applicationFields";
import applicationDirectors from "./resources/applicationDirectors";
import posApplicationResource from './resources/posApplication';
import dashboardResource from "./resources/dashboard";
import kyc from "./resources/kyc";

const resources = {
    auth: auth,
    blogs: blog,
    country: country,
    contact: contact,
    director: director,
    industry: industry,
    provider: provider,
    platform: platform,
    leads: leadResource,
    users: userResource,
    nationality: nationality,
    companiesHouse: companiesHouse,
    leadSource: leadSourceResource,
    activities: activityResource,
    partners: partnerResource,
    applications: applicationResource,
    applicationFields: applicationFields,
    applicationDirectors: applicationDirectors,
    posApplications: posApplicationResource,
    dashboardResource: dashboardResource,
    kyc: kyc,
};

export const resourceFactory = {
    get: name => resources[name]
};
